module.exports = "//cdn.mxpnl.com/static/asset-cache/6c49725dc76655c2c2c339364414fe62/iron/common/widgets/demo-selector-modal/assets/icons/Media.svg";